module.exports = __webpack_public_path__ + "img/google-1-1.e6c7b43f.svg";